/* Recommendations use the theme's existing product forms, stock checks and cart. */
(() => {
  if (window.bbFirstOrderLoaded) return;
  window.bbFirstOrderLoaded = true;
  const storageKey = 'blueboat:first-order:return';
  let generatedMessage = '';

  const selectionMessage = (panel) => {
    const names = Array.from(panel.querySelectorAll('[data-bb-starter-product]'), card => card.dataset.productTitle);
    const lines = [`Hola Blueboat, me interesa ${panel.dataset.starterName}.`];
    if (names.length) lines.push('Productos que me interesan:', ...names.map(name => `• ${name}`));
    lines.push('Quisiera una cotización con cantidades, disponibilidad y condiciones para mi primer pedido.');
    return lines.join('\n');
  };

  const openPanel = (root, panel, move = true) => {
    root.querySelectorAll('[data-bb-starter-panel]').forEach(item => { item.hidden = item !== panel; });
    root.querySelectorAll('[data-bb-starter-open]').forEach(link => {
      link.setAttribute('aria-expanded', String(link.getAttribute('aria-controls') === panel.id));
    });
    if (move) {
      const heading = panel.querySelector('h3');
      heading?.focus({ preventScroll: true });
      if (typeof scrollSectionBelowHeader === 'function') scrollSectionBelowHeader(panel);
      else panel.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  };

  const fillQuote = (panel) => {
    const form = document.querySelector('[data-bb-contact-form]');
    if (!form || form.classList.contains('is-success')) return;
    const message = form.elements.namedItem('contact[body]');
    const selection = form.querySelector('[data-bb-starter-selection-input]');
    const banner = form.querySelector('[data-bb-starter-selection]');
    if (message) {
      let note = message.value;
      if (generatedMessage && note.includes(generatedMessage)) note = note.replace(generatedMessage, '').trim();
      generatedMessage = selectionMessage(panel);
      message.value = generatedMessage + (note.trim() ? `\n\n${note.trim()}` : '');
      message.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (selection) { selection.disabled = false; selection.value = panel.dataset.starterName; }
    if (banner) {
      banner.hidden = false;
      banner.querySelector('[data-bb-starter-selection-name]').textContent = panel.dataset.starterName;
    }
    const name = form.elements.namedItem('contact[Nombre]');
    name?.focus({ preventScroll: true });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-bb-starter]').forEach(root => {
      if (root.dataset.starterReady) return;
      root.dataset.starterReady = 'true';
      root.addEventListener('click', event => {
        const opener = event.target.closest('[data-bb-starter-open]');
        if (opener) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const panel = document.getElementById(opener.getAttribute('aria-controls'));
          if (!panel) return;
          event.preventDefault();
          event.stopPropagation();
          openPanel(root, panel);
          history.replaceState(history.state, '', `${location.pathname}${location.search}#${panel.id}`);
        }
        const closer = event.target.closest('[data-bb-starter-close]');
        if (closer) {
          const panel = closer.closest('[data-bb-starter-panel]');
          panel.hidden = true;
          const link = Array.from(root.querySelectorAll('[data-bb-starter-open]')).find(item => item.getAttribute('aria-controls') === panel.id);
          link?.setAttribute('aria-expanded', 'false');
          link?.focus();
          history.replaceState(history.state, '', `${location.pathname}${location.search}#primer-pedido`);
        }
        const quote = event.target.closest('[data-bb-starter-quote]');
        if (quote) {
          fillQuote(quote.closest('[data-bb-starter-panel]'));
          if (window.matchMedia('(max-width: 749px)').matches) {
            const target = document.getElementById('cotizar');
            if (target) {
              event.preventDefault();
              const header = document.querySelector('.bb-header');
              const headerHeight = header ? header.getBoundingClientRect().height : 60;
              const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 12;
              window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
              history.replaceState(history.state, '', `${location.pathname}${location.search}#cotizar`);
            }
          }
        }
        const login = event.target.closest('[data-bb-starter-login]');
        if (login) {
          const panel = login.closest('[data-bb-starter-panel]');
          try { sessionStorage.setItem(storageKey, JSON.stringify({ name: panel.dataset.starterName, time: Date.now() })); } catch (_) { /* Login still works without storage. */ }
        }
      });
      root.querySelectorAll('[data-bb-starter-whatsapp]').forEach(link => {
        try {
          const url = new URL(link.href);
          url.searchParams.set('text', selectionMessage(link.closest('[data-bb-starter-panel]')));
          link.href = url.href;
        } catch (_) { /* Retain the merchant's configured link. */ }
      });
      let returning = null;
      try {
        returning = JSON.parse(sessionStorage.getItem(storageKey));
        if (returning && Date.now() - returning.time > 3600000) returning = null;
      } catch (_) { /* Optional context only. */ }
      const panels = Array.from(root.querySelectorAll('[data-bb-starter-panel]'));
      const matched = panels.find(panel => `#${panel.id}` === location.hash) || (returning && panels.find(panel => panel.dataset.starterName === returning.name));
      if (matched) openPanel(root, matched, Boolean(returning));
      if (returning && root.querySelector('form[action*="/cart/add"]')) {
        try { sessionStorage.removeItem(storageKey); } catch (_) { /* Optional context only. */ }
      }
    });
  };
  document.addEventListener('click', event => {
    const clear = event.target.closest('[data-bb-starter-selection-clear]');
    if (!clear) return;
    const form = clear.closest('form');
    const message = form.elements.namedItem('contact[body]');
    if (message && generatedMessage) message.value = message.value.replace(generatedMessage, '').trim();
    generatedMessage = '';
    const input = form.querySelector('[data-bb-starter-selection-input]');
    if (input) { input.value = ''; input.disabled = true; }
    form.querySelector('[data-bb-starter-selection]').hidden = true;
    message?.focus({ preventScroll: true });
  });
  window.addEventListener('hashchange', () => {
    document.querySelectorAll('[data-bb-starter-panel]').forEach(panel => {
      if (`#${panel.id}` === location.hash) openPanel(panel.closest('[data-bb-starter]'), panel, false);
    });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const link = event.target.closest('[data-bb-starter-open]') || event.target.querySelector('[data-bb-starter-open]');
    if (!link) return;
    const panel = document.getElementById(link.getAttribute('aria-controls'));
    if (panel) openPanel(link.closest('[data-bb-starter]'), panel, false);
  });
})();
